import { render, staticRenderFns } from "./DraggerImgDay.vue?vue&type=template&id=60f92dff&scoped=true"
import script from "./DraggerImgDay.vue?vue&type=script&lang=ts"
export * from "./DraggerImgDay.vue?vue&type=script&lang=ts"
import style0 from "./DraggerImgDay.vue?vue&type=style&index=0&id=60f92dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f92dff",
  null
  
)

export default component.exports